import React, { useState } from "react";
import { api, extractError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UserAvatar } from "@/components/UserAvatar";

export default function Profile() {
    const { user, refresh } = useAuth();
    const [prof, setProf] = useState({ first_name: user?.first_name || "", last_name: user?.last_name || "", email_notifications: !!user?.email_notifications });
    const [pw, setPw] = useState({ current_password: "", new_password: "" });
    const [msg, setMsg] = useState(""); const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const saveProfile = async (e) => {
        e.preventDefault(); setMsg(""); setErr(""); setBusy(true);
        try { await api.patch("/users/me/profile", prof); await refresh(); setMsg("Profilo salvato"); }
        catch (e) { setErr(extractError(e)); } finally { setBusy(false); }
    };
    const savePw = async (e) => {
        e.preventDefault(); setMsg(""); setErr(""); setBusy(true);
        try { await api.post("/auth/change-password", pw); setPw({ current_password: "", new_password: "" }); setMsg("Password aggiornata"); }
        catch (e) { setErr(extractError(e)); } finally { setBusy(false); }
    };
    const uploadAvatar = async (e) => {
        const f = e.target.files?.[0]; if (!f) return;
        const fd = new FormData(); fd.append("file", f);
        try { await api.post("/users/me/avatar", fd, { headers: { "Content-Type": "multipart/form-data" } }); await refresh(); setMsg("Immagine profilo aggiornata"); }
        catch (e) { setErr(extractError(e)); }
    };

    return (
        <div className="p-6 max-w-3xl" data-testid="profile-page">
            <h1 className="font-display text-2xl font-semibold tracking-tight text-neutral-900 mb-4">Profilo</h1>
            <div className="bg-white border border-neutral-200 rounded-md p-5 mb-4">
                <div className="flex items-center gap-4">
                    <UserAvatar user={user} size={56} />
                    <div className="flex-1">
                        <div className="font-medium">{user?.first_name} {user?.last_name}</div>
                        <div className="text-sm text-neutral-500">{user?.email} · {user?.role === "admin" ? "Amministratore" : "Collaboratore"}</div>
                    </div>
                    <label className="text-sm bg-neutral-100 border border-neutral-200 hover:bg-neutral-200 rounded px-3 py-1.5 cursor-pointer">
                        Cambia foto
                        <input type="file" accept="image/*" onChange={uploadAvatar} className="hidden" data-testid="avatar-input" />
                    </label>
                </div>
            </div>

            <form onSubmit={saveProfile} className="bg-white border border-neutral-200 rounded-md p-5 mb-4 space-y-3">
                <div className="font-display font-semibold">Dati personali</div>
                <div className="grid grid-cols-2 gap-3">
                    <F label="Nome"><input value={prof.first_name} onChange={(e) => setProf({ ...prof, first_name: e.target.value })} className="w-full text-sm border border-neutral-300 rounded px-2 py-1.5" /></F>
                    <F label="Cognome"><input value={prof.last_name} onChange={(e) => setProf({ ...prof, last_name: e.target.value })} className="w-full text-sm border border-neutral-300 rounded px-2 py-1.5" /></F>
                </div>
                <label className="text-sm inline-flex items-center gap-2">
                    <input type="checkbox" checked={prof.email_notifications} onChange={(e) => setProf({ ...prof, email_notifications: e.target.checked })} />
                    Ricevi riepilogo email
                </label>
                <button disabled={busy} className="text-sm bg-neutral-900 text-white rounded px-3 py-1.5 hover:bg-neutral-800 disabled:opacity-60">Salva profilo</button>
            </form>

            <form onSubmit={savePw} className="bg-white border border-neutral-200 rounded-md p-5 space-y-3">
                <div className="font-display font-semibold">Cambia password</div>
                <F label="Password attuale"><input type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="w-full text-sm border border-neutral-300 rounded px-2 py-1.5" /></F>
                <F label="Nuova password"><input type="password" required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="w-full text-sm border border-neutral-300 rounded px-2 py-1.5" /></F>
                <button disabled={busy} className="text-sm bg-neutral-900 text-white rounded px-3 py-1.5 hover:bg-neutral-800 disabled:opacity-60">Aggiorna password</button>
            </form>

            {msg && <div className="mt-3 text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded p-2">{msg}</div>}
            {err && <div className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2">{err}</div>}
        </div>
    );
}
function F({ label, children }) { return <label className="block"><span className="text-xs font-medium text-neutral-600">{label}</span><div className="mt-1">{children}</div></label>; }
